// extracted by mini-css-extract-plugin
export var headerXL = "BlogPostMetadata-module--headerXL--1tfH9";
export var headerL = "BlogPostMetadata-module--headerL--1Onk6";
export var headerM = "BlogPostMetadata-module--headerM--_0qh9";
export var headerS = "BlogPostMetadata-module--headerS--2uXEN";
export var headerXS = "BlogPostMetadata-module--headerXS--lIdWL";
export var blogHeaderXL = "BlogPostMetadata-module--blogHeaderXL--3dNAb";
export var blogHeaderL = "BlogPostMetadata-module--blogHeaderL--21LYa";
export var blogHeaderM = "BlogPostMetadata-module--blogHeaderM--P0ZNq";
export var blogHeaderS = "BlogPostMetadata-module--blogHeaderS--fkAuY";
export var blogHeaderXS = "BlogPostMetadata-module--blogHeaderXS--2WlrG";
export var headerPreamble = "BlogPostMetadata-module--headerPreamble--2OFWQ";
export var preHeader = "BlogPostMetadata-module--preHeader--2nkXo";
export var textNormal = "BlogPostMetadata-module--textNormal--1b1by";
export var textSmall = "BlogPostMetadata-module--textSmall--5EspW";
export var textSmallAlternate = "BlogPostMetadata-module--textSmallAlternate--8_CSS";
export var legend = "BlogPostMetadata-module--legend--1kvJ_";
export var caption = "BlogPostMetadata-module--caption--3wXOr";
export var gradientBackground = "BlogPostMetadata-module--gradientBackground--1vYz6";
export var ellipsis = "BlogPostMetadata-module--ellipsis--1cwzA";
export var globalContainer = "BlogPostMetadata-module--globalContainer--NCHu0";
export var maxWidth = "BlogPostMetadata-module--maxWidth--ErtTX";
export var clipBottom = "BlogPostMetadata-module--clipBottom--1AEPH";
export var clipTopBottom = "BlogPostMetadata-module--clipTopBottom--3qLuM";
export var metaData = "BlogPostMetadata-module--metaData--2eehF";
export var ch2 = "BlogPostMetadata-module--ch2--2UfpR";
export var ch2Container = "BlogPostMetadata-module--ch2-container--1jyK2";